import { render } from "./gemstone-drawer.vue?vue&type=template&id=22c2e878"
import script from "./gemstone-drawer.vue?vue&type=script&lang=js"
export * from "./gemstone-drawer.vue?vue&type=script&lang=js"

import "./gemstone-drawer.vue?vue&type=style&index=0&id=22c2e878&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__